import { useEffect, useState } from 'react';

export const useAnchor = () => {
    const [anchor, setAnchor] = useState('');

    useEffect(() => {
        const updateAnchor = () => {
            setAnchor(window.location.hash.slice(1));
        };

        updateAnchor();
        window.addEventListener('hashchange', updateAnchor);

        return () => window.removeEventListener('hashchange', updateAnchor);
    }, []);

    return anchor;
};
